    import React, { useState, useEffect } from "react";
    import { withRouter } from "react-router-dom";
    import Table from "@empd/reactable";
    import "@empd/reactable/lib/styles.css";

    import {
        Container,
        Row,
        Col,
        Card,
        CardImg,
        Form,
        Button,
        Breadcrumb,
        Spinner,
        Alert,
        Modal,
        Dropdown,
    } from "react-bootstrap";

    import CustomNavbar from "../../components/CustomNavbar";
    import CustomFooter from "../../components/CustomFooter";
    import ShowInfo from "../../components/ShowInfo";

    import api from "../../service/api";

    const BackgroundNewTabloid = (props) => {
        const [backgrounds, setBackgrounds] = useState([]);
        const [emptyDataElement, setEmptyDataElement] = useState(
            <Spinner animation="grow" />
        );
        const [showAlert, setShowAlert] = useState(false);
        const [alertTitle, setAlertTitle] = useState("");
        const [alertText, setAlertText] = useState("");
        const [alertVariant, setAlertVariant] = useState("");

        useEffect(
            function () {
                async function load() {
                    const backgrounds = await api.get('/background/list');
                    if (backgrounds) {
                        if (backgrounds.length === 0) {
                            setEmptyDataElement(
                                <Alert variant="dark">Não existem registros.</Alert>
                            );
                        } else {
                            setBackgrounds(backgrounds.data.data);
                        }
                    } else {
                        alert("Erro ao buscar os fundos. Contate o suporte!");
                        setTimeout(function () {
                            props.history.push("/dashboard");
                        }, 2000);
                    }
                }

                load();
            },
            [props.history]
        );

        return (
            <>
                <CustomNavbar />
                <main>
                    <Container>
                        <Row>
                            <Col>
                                <ShowInfo
                                    title={alertTitle}
                                    text={alertText}
                                    show={showAlert}
                                    variant={alertVariant}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Breadcrumb>
                                    <Breadcrumb.Item
                                        style={{
                                            cursor: "pointer",
                                        }}
                                        onClick={() =>
                                            props.history.push("/dashboard")
                                        }
                                    >
                                        Dashboard
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item active>
                                        Listar Fundos
                                    </Breadcrumb.Item>
                                </Breadcrumb>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Table
                                    searchPlaceholder="Procurar"
                                    emptyPlaceholder={emptyDataElement}
                                    columns={[
                                        {
                                            name: "ID",
                                            sortable: true,
                                            selector: "id",
                                        },
                                        {
                                            name: "Nome",
                                            sortable: true,
                                            selector: "name",
                                        },
                                        {
                                            name: "Opções",
                                            cell: function (cellInfo) {
                                                return (
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            variant="success"
                                                            id="dropdown-basic"
                                                        >
                                                            Opções
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu
                                                            style={{
                                                                padding: 0,
                                                            }}
                                                        >
                                                            <Dropdown.Item
                                                                style={{
                                                                    padding: 0,
                                                                }}
                                                            >
                                                                <Button
                                                                    style={{
                                                                        width:
                                                                            "100%",
                                                                        borderRadius: 0,
                                                                    }}
                                                                    variant="danger"
                                                                    onClick={() => {
                                                                        var trash = window.confirm(
                                                                            "Para Excluir pressione OK!"
                                                                        );
                                                                        if (
                                                                            trash ===
                                                                            true
                                                                        ) {
                                                                            async function deleteAd(
                                                                                id
                                                                            ) {
                                                                                try {
                                                                                    const deleted = api.delete(
                                                                                        `/background/${id}`
                                                                                    );

                                                                                    if (
                                                                                        deleted
                                                                                    ) {
                                                                                        setShowAlert(
                                                                                            true
                                                                                        );
                                                                                        setAlertTitle(
                                                                                            "Fundo excluído com sucesso!"
                                                                                        );
                                                                                        setAlertText(
                                                                                            `A Fundo ${cellInfo.name} foi excluído com sucesso!`
                                                                                        );
                                                                                        setAlertVariant(
                                                                                            "success"
                                                                                        );
                                                                                    }
                                                                                } catch (err) {
                                                                                    setShowAlert(
                                                                                        true
                                                                                    );
                                                                                    setAlertTitle(
                                                                                        "Não foi possível excluir o Fundo!"
                                                                                    );
                                                                                    setAlertText(
                                                                                        `O Fundo ${cellInfo.name} não pode ser excluído. Contate o suporte!`
                                                                                    );
                                                                                    setAlertVariant(
                                                                                        "danger"
                                                                                    );
                                                                                }
                                                                            }
                                                                            deleteAd(
                                                                                cellInfo.id
                                                                            );
                                                                        }
                                                                    }}
                                                                >
                                                                    Excluir
                                                                </Button>
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                );
                                            },
                                        },
                                    ]}
                                    data={backgrounds}
                                />
                            </Col>
                        </Row>
                    </Container>
                </main>
                <CustomFooter />
            </>
        );
    };

    export default withRouter(BackgroundNewTabloid);
